var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-row", [_vm.accountInfo.tag != 0 ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单归属")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保单归属"),
      "show-search": "",
      "option-filter-prop": "label"
    },
    on: {
      change: _vm.customerChange
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList2, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单号")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("保单号")
    },
    model: {
      value: _vm.form.policyNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyNo", $$v);
      },
      expression: "form.policyNo"
    }
  }, _vm._l(_vm.policyNoList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.policyNo
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.policyNo
      }
    }, [_vm._v(" " + _vm._s(item.policyNo) + " ")])], 1);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("操作人")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("操作人"),
      allowClear: ""
    },
    model: {
      value: _vm.form.operator,
      callback: function ($$v) {
        _vm.$set(_vm.form, "operator", $$v);
      },
      expression: "form.operator"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("操作类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("操作类型")
    },
    model: {
      value: _vm.form.recordType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "recordType", $$v);
      },
      expression: "form.recordType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: ""
    }
  }, [_vm._v(_vm._s(_vm.$t("全部")))]), _c("a-select-option", {
    attrs: {
      value: "INCREASE"
    }
  }, [_vm._v(_vm._s(_vm.$t("增员")))]), _c("a-select-option", {
    attrs: {
      value: "REDUCE"
    }
  }, [_vm._v(_vm._s(_vm.$t("减员")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("操作时间"),
      prop: "time"
    }
  }, [_c("a-range-picker", {
    attrs: {
      format: _vm.getFormatDate()
    },
    model: {
      value: _vm.form.time,
      callback: function ($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("人员名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("人员名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("身份证号"),
      prop: "idNumber"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("身份证号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.idNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "idNumber", $$v);
      },
      expression: "form.idNumber"
    }
  })], 1)], 1)], 1), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.resetSearch
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("customer.personnelDetailsRecordExport") ? _c("a-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function ($event) {
        _vm.exportVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("导出")))]) : _vm._e()], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "recordType",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text == "INCREASE" ? _vm.$t("增员") : _vm.$t("减员")) + " ")];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("customer.personnelDetailsRecordDetail") ? _c("a-button", {
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.openDetail(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("detail-export-modal", {
    attrs: {
      visible: _vm.exportVisible,
      customerId: _vm.form.customerId
    },
    on: {
      cancel: function ($event) {
        _vm.exportVisible = false;
      }
    }
  }), _c("operating-detail", {
    attrs: {
      visible: _vm.detailVisible,
      policyId: _vm.policyId,
      personnelDetailsId: _vm.personnelDetailsId
    },
    on: {
      cancel: function ($event) {
        _vm.detailVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };